/* @flow weak */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'CREATE_PAYMENT_SOURCE',
  'DELETE_PAYMENT_SOURCE',
  'LOAD_PAYMENT_SOURCES',
]);



// WEBPACK FOOTER //
// ./src/payments/constants/PaymentSourceConstants.js